import { snapshot } from 'valtio';
import { logger } from 'logging-utils';
import irrelevantAppsService from '../services';
import {
  setIrrelevantApps,
  setIrrelevantAppsError,
  setIsLoadingIrrelevantApps,
  setIsRemoveIrrelevantAppLoading,
  setRelevetAppModal,
  setShowMakeRelevantDialog,
} from '../store-actions/irrelevant-apps-store-actions';
import ReasonFiltersStore, {
  ReasonFilterType,
} from '../stores/reason-filters-store';
import { updateFilters, setLoadingFilters } from './reason-filters-actions';
import IrrelevantAppsStore from '../stores/irrelevant-apps-store';
import { createSimpleAsyncAction } from 'async-utils';
import { openSnackbar } from '../../snackbar/actions/snackbar-actions';
import { RemoveAppExclusionInput } from '../services/remove-app-exclusion/remove-app-exclusion';
import { snackBarSpplitingName } from '../../exclusions/utils/exclusion-utils';
import { ApplicationsFilters } from '../irrelevant-apps-types';

export const loadIrrelevantApps = async (reasonFilter?: ReasonFilterType) => {
  try {
    if (reasonFilter) {
      updateFilters(reasonFilter);
    }
    const { filters } = snapshot(ReasonFiltersStore);

    setLoadingFilters(true);
    const result = await irrelevantAppsService.getIrrelevantApps.execute({
      applicationFilters: [ApplicationsFilters.Irrelevant],
      irrelevancyFilters: filters,
    });

    if (!result.length) {
      setIrrelevantAppsError(false, 'No irrelevant apps found');
    }

    if (!result) {
      logger.error('Failed to load irrelevant apps results');
      setIrrelevantAppsError(true, 'Failed to load irrelevant apps results');
    }
    setLoadingFilters(false);
    setIrrelevantApps(result);
    setIsLoadingIrrelevantApps(false);
  } catch (err) {
    logger.error('Failed to load irrelevant apps results', err);
    setIrrelevantAppsError(
      true,
      `Failed to load irrelevant apps results: ${err}`,
    );
  } finally {
    setLoadingFilters(false);
  }
};

export const removeIrrelevantApp = (appId: string) => {
  const { irrelevantApps } = snapshot(IrrelevantAppsStore);
  const updatedApps = irrelevantApps.result.filter(app => app.appId !== appId);
  IrrelevantAppsStore.irrelevantApps = {
    ...irrelevantApps,
    result: updatedApps,
  };
};

export const removeAppExclusion = createSimpleAsyncAction(
  async (input: RemoveAppExclusionInput) => {
    try {
      setIsRemoveIrrelevantAppLoading(true);
      const res = await irrelevantAppsService.removeAppExclusion.execute(input);
      if (res.isSucceded) {
        const filteredApps = IrrelevantAppsStore.apps.filter(
          app => app.appId !== input.exclusionId,
        );

        setIrrelevantApps(filteredApps);
        setIsRemoveIrrelevantAppLoading(false);
        setRelevetAppModal(false);
        openSnackbar(
          `The following app has been made relevant: ${snackBarSpplitingName(
            input.appName,
          )}`,
          {
            variant: 'success',
          },
        );
      }
    } catch (e) {
      logger.error(
        `There was an error making this app relevant: ${input.appName}`,
      );
      setIsRemoveIrrelevantAppLoading(false);
      setShowMakeRelevantDialog(false);
      openSnackbar(
        `There was an error making this app relevant: ${snackBarSpplitingName(
          input.appName,
        )}`,
        {
          variant: 'error',
        },
      );
    }
  },
  {
    asyncState: IrrelevantAppsStore.loading,
    errorMessage: 'Failed to remove app exclusion',
  },
);

export const changeToReleventApp = () => {
  if (IrrelevantAppsStore.selectedReleventApp !== null) {
    removeAppExclusion({
      appName: IrrelevantAppsStore.selectedReleventApp.name,
      exclusionId: IrrelevantAppsStore.selectedReleventApp.appId,
      relevance: IrrelevantAppsStore.releventType,
    });
  }
};
